import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import StaticMap from '../../../../components/static-map/static-map';
import StoreQuickViewList, {
  LIST_TYPE
} from '../../../../components/store-quick-view-list/store-quick-view-list';

import {
  getStoreDetailsUrl,
  getStoreHours
} from '../../../../shared/utils/store/store';

import './nearest-stores.scss';

class NearestStores extends PureComponent {
  static propTypes = {
    centerPos: PropTypes.shape({
      latitude: PropTypes.number,
      longitude: PropTypes.number
    }).isRequired,
    isMyStore: PropTypes.bool,
    mapHeight: PropTypes.number.isRequired,
    mapWidth: PropTypes.number.isRequired,
    stores: PropTypes.array.isRequired
  };

  getMapZoom = () => {
    const { stores } = this.props;
    const dist = stores.length > 0 ? stores[stores.length - 1].distance : 0;
    let zoom = 12;

    if (dist > 7) zoom = 11;
    if (dist > 40) zoom = 10;
    if (dist > 65) zoom = 9;
    if (dist > 85) zoom = 8;
    if (dist > 100) zoom = 7;
    if (dist > 250) zoom = 6;

    return zoom;
  };

  render() {
    const { centerPos, isMyStore, mapHeight, mapWidth, stores } = this.props;
    const markers = stores.map(s => ({
      isPitpass: Boolean(s?.pitPass),
      latitude: s?.geoPoint?.latitude,
      longitude: s?.geoPoint?.longitude
    }));

    const storeQuickViews = window.isPreRendering
      ? []
      : stores?.map(store => ({
          address: store?.address,
          baseStore: store?.baseStore,
          distance: store?.distance,
          geoPoint: store?.geoPoint,
          legacyStoreCode: store?.legacyStoreCode,
          pitPass: store?.pitPass,
          rating: store?.rating,
          storeCode: store?.code,
          storeDetailsLink: getStoreDetailsUrl(store?.address, store?.code),
          storeHours: getStoreHours()
        }));

    return (
      <div styleName="container">
        <div styleName="stores">
          <StoreQuickViewList
            listType={LIST_TYPE.MINIMAL}
            stores={storeQuickViews}
          />
        </div>
        <div styleName="map">
          <StaticMap
            centerPos={centerPos}
            height={mapHeight}
            isMyStore={isMyStore}
            markers={markers}
            width={mapWidth}
            zoom={this.getMapZoom()}
          />
        </div>
      </div>
    );
  }
}

export default NearestStores;
